import _ from 'lodash';
import { PARAMETER_ID } from './config';
import powerSeries from './scripts/power';
import polynomialSeries from './scripts/polynomial';

export const findLineByLeastSquares = (values_x, values_y, actual_x) => {
  let sum_x = 0;
  let sum_y = 0;
  let sum_xy = 0;
  let sum_xx = 0;
  let sum_yy = 0;
  let count = 0;

  /*
   * We'll use those letiables for faster read/write access.
   */
  let x = 0;
  let y = 0;
  let values_length = values_x.length;

  if (values_length != values_y.length) {
    throw new Error('The parameters values_x and values_y need to have same size!');
  }

  /*
   * Nothing to do.
   */
  if (values_length === 0) {
    return [[], []];
  }

  /*
   * Calculate the sum for each of the parts necessary.
   */
  for (let i = 0; i < values_length; i++) {
    x = values_x[i];
    y = values_y[i];
    sum_x += x;
    sum_y += y;
    sum_xx += x * x;
    sum_xy += x * y;
    sum_yy += y * y
    count++;
  }

  /*
   * Calculate m and b for the formular:
   * y = x * m + b
   */

  let B = ((sum_y * sum_x - count * sum_xy) / (sum_x * sum_x - count * sum_xx))

  let A = (sum_y - (B * sum_x)) / count

  /*
   * We will make the x and y result line now
   */
  let result_values_x = [];
  let result_values_y = [];

  for (let i = 0; i < values_length; i++) {
    x = actual_x[i];
    y = Math.exp(A) * Math.pow(actual_x[i], B)
    result_values_x.push(x);
    result_values_y.push(y);
  }
  // console.log(result_values_x, result_values_y)
  let r2 = Math.pow((count * sum_xy - sum_x * sum_y) / Math.sqrt((count * sum_xx - sum_x * sum_x) * (count * sum_yy - sum_y * sum_y)), 2);
  return [result_values_x, result_values_y, [A, B, r2]];
}

export const getByDate = (parameters, stageRange, stage, discharge) => {
  let observationByDate = {};

  let stageParameter = _.get(parameters.find(parameter => +parameter.parameter_id === +stage), 'data', null);
  let dischargeParameter = _.get(parameters.find(parameter => +parameter.parameter_id === +discharge), 'data', null);

  if (!!stageParameter && !!dischargeParameter) {
    stageParameter.forEach(observation => {
      let waterLevel = _.get(observation, 'value');
      let discharge = _.get(dischargeParameter.find(item => item.time === observation.time), 'value');

      observationByDate[observation.time] = {
        'WL_M': waterLevel,
        'Q_M': discharge,
      }

      let disabled = (!waterLevel && +waterLevel !== 0) || (!discharge && +discharge !== 0);
      observationByDate[observation.time].disabled = disabled;
      observationByDate[observation.time].checked = disabled ? false : (waterLevel >= stageRange.from && waterLevel <= stageRange.to)
    });

    // dischargeParameter.forEach(observation => {
    //   let x = observationByDate[observation.time];
    //   let value = observation.value;
    //   if (!!x) {
    //     observationByDate[observation.time].Q_M = value || 0.001;
    //   } else {
    //     observationByDate[observation.time] = {
    //       'Q_M': value || 0.001,
    //     }
    //   }
    //   observationByDate[observation.time].disabled = observationByDate[observation.time].disabled || (!value && +value !== 0)
    // });

  }
  // parameters.forEach(parameter => {
  //   if (!!parameter.data) parameter.data.forEach(observation => {
  //     let x = observationByDate[observation.time];
  //     let value = observation.value;

  //     if (!!x) {
  //       observationByDate[observation.time][parameter.parameter_code] = value || 0.001;
  //     } else {
  //       observationByDate[observation.time] = {
  //         [parameter.parameter_code]: value || 0.001
  //       }
  //       observationByDate[observation.time].checked = true;
  //     }
  //     let wl = stage || PARAMETER_ID.waterLevel;
  //     if (+parameter.parameter_id === +wl) {
  //       observationByDate[observation.time].checked = observationByDate[observation.time].checked && (value >= stageRange.from && value <= stageRange.to)
  //     }
  //   })
  // });
  return observationByDate;
}

export const notNull = value => !!value || +value === 0;
export const roundOff = (value, precision = 4) => !!parseFloat(value) ? Math.floor(+value * Math.pow(10, precision)) / Math.pow(10, precision) : value;
export const stageAddition = (a, b = 0.001, precision = 3) => {
  let multiplier = 10 ** precision;
  return (Math.round(multiplier * a) + Math.round(multiplier * b)) / multiplier;
}
export const deriveRatingEquation = (data, series_type = 1) => {
  switch (+series_type) {
    case 1: return powerSeries(data);
    case 2: return polynomialSeries(data);
    default: return null;
  }
}

export const getRatingCurve = (data, { a, b, c, offset, type }) => {
  const min_x = _.min(data.map(item => item[0]));
  const max_x = _.max(data.map(item => item[0]));

  let normalSeries = [];
  let logSeries = [];
  let errors = []
  let Exy = 0, Ex = 0, Ey = 0, Ex2 = 0, Ex_2 = 0, Ey2 = 0, Ey_2 = 0, n = data.length;

  let i = min_x;
  while (i <= max_x) {
    let x = i;
    let y = (() => {
      switch (type) {
        case 1: return a * (x ** b);            // Power Series
        case 2: return a + b * x + c * x * x;   // Polynomial Series
        default: return null;
      }
    })();
    let X = Math.log(x),
      Y = Math.log(y);

    let all_obs_for_x = data.filter(item => +item[0] === +x);
    // eslint-disable-next-line
    all_obs_for_x.forEach(obs_data => {
      let obs_y = obs_data[1];
      let Y_ = Math.log(obs_y);
      errors.push((obs_y - y) ** 2);
      Exy += X * Y_;
      Ex += X;
      Ey += Y_;
      Ex2 += X * X;
      Ey2 += Y_ * Y_;
    });

    normalSeries.push([x, y]);
    logSeries.push([X, Y])
    i = stageAddition(i)
  }

  let r2 = 0, rmse = Math.sqrt(_.mean(errors));

  if (type === 1) {
    r2 = ((n * Exy - Ex * Ey) / (Math.sqrt((n * Ex2 - Ex * Ex) * (n * Ey2 - Ey * Ey)))) ** 2;
  } else if (type === 2) {
    let sum_diff_sq = _.sum(errors),
      mean_obs_y = Ey / n,
      sum_diff_mean_sq = _.sum(data.map(item => (item[1] - mean_obs_y) ** 2));
    r2 = 1 - (sum_diff_sq / sum_diff_mean_sq);
  }

  return {
    normalSeries,
    logSeries,
    rmse,
    r2,
  };
}


// WEBPACK FOOTER //
// ./src/components/Hydrology/RTEquations/helpers.js